export function loadVideoSource(video: HTMLVideoElement) {
  if (video.getAttribute("src") || !video.dataset.src) return;
  const mobile = window.matchMedia("(max-width: 767px)").matches;
  const isHero =
    video.classList.contains("hero-video") ||
    video.dataset.src.includes("home-hero");
  video.src =
    mobile && !isHero
      ? video.dataset.src.replace("/videos/previews/", "/videos/previews/mobile/")
      : video.dataset.src;
  video.preload = "auto";
  video.load();
}

export function preloadVideo(video: HTMLVideoElement) {
  const motion = window.matchMedia("(prefers-reduced-motion: reduce)");
  let near = false;
  const prepare = () => {
    if (near && !motion.matches && !document.hidden) loadVideoSource(video);
  };
  const observer = new IntersectionObserver(
    ([entry]) => {
      near = entry.isIntersecting;
      prepare();
    },
    { rootMargin: "240px 0px", threshold: 0 },
  );
  observer.observe(video);
  motion.addEventListener("change", prepare);
  document.addEventListener("visibilitychange", prepare);
  return {
    destroy() {
      observer.disconnect();
      motion.removeEventListener("change", prepare);
      document.removeEventListener("visibilitychange", prepare);
    },
  };
}
